const featuresModule = {
  state: {
    login: true,
    ingredients: true,
    facebookPage: true,
    recipeList: false,
    autoDeleteAccount: false
  }
};

export default featuresModule;
